/* tslint:disable */
/* eslint-disable */
/**
 * Prove Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetHistories200ResponseHistoriesInnerGps } from './GetHistories200ResponseHistoriesInnerGps';
import {
    GetHistories200ResponseHistoriesInnerGpsFromJSON,
    GetHistories200ResponseHistoriesInnerGpsFromJSONTyped,
    GetHistories200ResponseHistoriesInnerGpsToJSON,
    GetHistories200ResponseHistoriesInnerGpsToJSONTyped,
} from './GetHistories200ResponseHistoriesInnerGps';

/**
 * 
 * @export
 * @interface GetHistories200ResponseHistoriesInner
 */
export interface GetHistories200ResponseHistoriesInner {
    /**
     * タイムスタンプ
     * @type {Date}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    timestamp?: Date;
    /**
     * 無線グループID
     * @type {string}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    companyCode?: string;
    /**
     * 無線機番号
     * @type {string}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    radioNo?: string;
    /**
     * ログインID
     * @type {string}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    loginId?: string;
    /**
     * 
     * @type {GetHistories200ResponseHistoriesInnerGps}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    gps?: GetHistories200ResponseHistoriesInnerGps;
    /**
     * 車両状態
     * @type {number}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    status?: number;
    /**
     * 配車可否
     * @type {boolean}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    available?: boolean;
    /**
     * 方向
     * @type {number}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    direction?: number;
    /**
     * 速度
     * @type {number}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    speed?: number;
    /**
     * 注文番号
     * @type {string}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    orderNo?: string;
    /**
     * 待機状態
     * @type {boolean}
     * @memberof GetHistories200ResponseHistoriesInner
     */
    waitFlag?: boolean;
}

/**
 * Check if a given object implements the GetHistories200ResponseHistoriesInner interface.
 */
export function instanceOfGetHistories200ResponseHistoriesInner(value: object): value is GetHistories200ResponseHistoriesInner {
    return true;
}

export function GetHistories200ResponseHistoriesInnerFromJSON(json: any): GetHistories200ResponseHistoriesInner {
    return GetHistories200ResponseHistoriesInnerFromJSONTyped(json, false);
}

export function GetHistories200ResponseHistoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistories200ResponseHistoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'radioNo': json['radio_no'] == null ? undefined : json['radio_no'],
        'loginId': json['login_id'] == null ? undefined : json['login_id'],
        'gps': json['gps'] == null ? undefined : GetHistories200ResponseHistoriesInnerGpsFromJSON(json['gps']),
        'status': json['status'] == null ? undefined : json['status'],
        'available': json['available'] == null ? undefined : json['available'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'speed': json['speed'] == null ? undefined : json['speed'],
        'orderNo': json['order_no'] == null ? undefined : json['order_no'],
        'waitFlag': json['wait_flag'] == null ? undefined : json['wait_flag'],
    };
}

export function GetHistories200ResponseHistoriesInnerToJSON(json: any): GetHistories200ResponseHistoriesInner {
    return GetHistories200ResponseHistoriesInnerToJSONTyped(json, false);
}

export function GetHistories200ResponseHistoriesInnerToJSONTyped(value?: GetHistories200ResponseHistoriesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'company_code': value['companyCode'],
        'radio_no': value['radioNo'],
        'login_id': value['loginId'],
        'gps': GetHistories200ResponseHistoriesInnerGpsToJSON(value['gps']),
        'status': value['status'],
        'available': value['available'],
        'direction': value['direction'],
        'speed': value['speed'],
        'order_no': value['orderNo'],
        'wait_flag': value['waitFlag'],
    };
}

